// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27eUt","questions":"styles_questions__27Jdj","footer":"styles_footer__1fdPY"};